import Swal from 'sweetalert2';
import React, { useEffect, useState } from "react";
import { useGuestContext } from '../../../contexts/GuestContext';
import {
    Form,
    Table,
  } from "react-bootstrap";
  import axios from 'axios'
import { getEventPin, handlePinAuthError } from "../../../utils/pinAuth";

function ChingMingCheckInConfirmation({details}) {
    const [alert, setAlert] = React.useState(null);
    const { language } = useGuestContext();

    const htmlContent = `
    <div style="overflow-x: auto;">
        <table style="width: 100%; border-collapse: collapse;">
            <thead>
                <tr style="background-color: #f2f2f2;">
                    <th style="text-align: left; padding: 8px;">${language === "English" ? "Field" : "字段"}</th>
                    <th style="text-align: center; padding: 8px;">${language === "English" ? "Value" : "值"}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td style="text-align: left; padding: 8px;">${language === "English" ? "Guest ID" : "客人编号"}</td>
                    <td style="text-align: center; padding: 8px;">${details.guestId}</td>
                </tr>
                <tr>
                    <td style="text-align: left; padding: 8px;">${language === "English" ? "Name" : "姓名"}</td>
                    <td style="text-align: center; padding: 8px;">${details.firstname} ${details.lastname}</td>
                </tr>
                <tr>
                    <td style="text-align: left; padding: 8px;">${language === "English" ? "Chinese Name" : "中文名"}</td>
                    <td style="text-align: center; padding: 8px;">${details.chinesename ? details.chinesename : (language === "English" ? "Not provided" : "無")}</td>
                </tr>
                <tr>
                    <td style="text-align: left; padding: 8px;">${language === "English" ? "Phone" : "电话"}</td>
                    <td style="text-align: center; padding: 8px;">${details.phone}</td>
                </tr>
                <tr>
                    <td style="text-align: left; padding: 8px;">${language === "English" ? "Email" : "电子邮件"}</td>
                    <td style="text-align: center; padding: 8px;">${details.email}</td>
                </tr>
                <tr>
                    <td style="text-align: left; padding: 8px;">${language === "English" ? "Timeslot" : "時段"}</td>
                    <td style="text-align: center; padding: 8px;">${details.timeslot ? details.timeslot : (language === "English" ? "Not specified" : "未指定")}</td>
                </tr>
                <tr>
                    <td style="text-align: left; padding: 8px;">${language === "English" ? "Relatives" : "親屬人數"}</td>
                    <td style="text-align: center; padding: 8px;">${details.relatives || 0}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div style="margin-top: 16px;">
        <label style="font-weight: bold;">${language === "English" ? "Group Size for Check-in" : "報到人數"}</label>
        <select id="groupSizeSelect" class="swal2-input" style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px; margin-top: 6px; font-size: 16px; background-color: white;">
            ${Array.from({ length: 15 }, (_, i) => `<option value="${i + 1}">${i + 1} ppl</option>`).join('')}
        </select>
    </div>
`;


    const hideAlert = () => {
        setAlert(null);
    };

    Swal.fire({
        title: language === "English" ? "You are about to Check in" : "報到確認",
        html: htmlContent,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: language === "English" ? "Yes, Check me in" : "完成報到",
        cancelButtonText: language === "English" ? "Cancel" : "取消報到",
        allowOutsideClick:false,
        preConfirm: () => {
            const groupSize = document.getElementById('groupSizeSelect').value;
            return { groupSize: parseInt(groupSize) };
        }
    }).then(async (result) => {
        if (result.isConfirmed) {
            const groupSize = result.value ? result.value.groupSize : 1;
            const pin = await getEventPin();
            // Send API request to backend
            axios.post(`${process.env.REACT_APP_SERVER_URL}/chingming/checkinconfirm`, {
                guestid: details.guestId,
                groupSize: groupSize
            }, { headers: { 'X-Event-Pin': pin } })
                .then(response => {
                    if (response.data && response.data.status === 'success') {
                        Swal.fire({
                            title: language === "English" ? `Check-in Successful` : `報到成功`,
                            text: language === "English" ? `Guest ID: ${details.guestId} has been checked in (Group of ${groupSize}).` : `ID為${details.guestId}的居士已報到（${groupSize}人）。`,
                            icon: 'success',
                            confirmButtonText: 'OK'
                        }).then(() => {
                            window.location.href = '/checkinSearch';
                        });
                    } else {
                        // Handle any other status or error
                        Swal.fire('Error', 'An error occurred during check-in', 'error');
                    }
                })
                .catch(error => {
                    if (error.response && error.response.status === 401) {
                        handlePinAuthError();
                    } else {
                        // Handle HTTP errors
                        Swal.fire('Error', 'An error occurred while sending data', 'error');
                    }
                });
        } else if (result.isDismissed) {
            window.location.href = '/checkinSearch';
        }
    });
    

    return (
        <>
            {alert}
        </>
    )
}
export default ChingMingCheckInConfirmation
